module.exports = __webpack_public_path__ + "static/media/clear_white.8f2d8255.svg";